var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.22806C0 0.549822 0.549822 0 1.22806 0H13.5087C13.8344 0 14.1467 0.129385 14.377 0.359691L24.9287 10.9113C25.6148 11.6016 26 12.5354 26 13.5087C26 14.482 25.6148 15.4157 24.9287 16.106L24.9261 16.1086L16.1214 24.9133C16.1212 24.9135 16.1215 24.9132 16.1214 24.9133C15.7793 25.2556 15.3727 25.5277 14.9256 25.713C14.4784 25.8984 13.999 25.9938 13.5148 25.9938C13.0307 25.9938 12.5512 25.8984 12.104 25.713C11.6568 25.5277 11.2506 25.256 10.9085 24.9136C10.9084 24.9135 10.9086 24.9137 10.9085 24.9136L0.360197 14.3775C0.129581 14.1472 0 13.8346 0 13.5087V1.22806ZM2.45612 2.45612V12.9996L12.645 23.1766L12.646 23.1775C12.76 23.2917 12.8955 23.3823 13.0445 23.4441C13.1936 23.5059 13.3534 23.5377 13.5148 23.5377C13.6762 23.5377 13.836 23.5059 13.9851 23.4441C14.1342 23.3823 14.2696 23.2917 14.3837 23.1775L23.1868 14.3745C23.1871 14.3741 23.1875 14.3737 23.1879 14.3733C23.4159 14.1433 23.5439 13.8326 23.5439 13.5087C23.5439 13.1848 23.4159 12.874 23.1879 12.644C23.1875 12.6436 23.1871 12.6433 23.1868 12.6429L13 2.45612H2.45612Z",
    fill: "#5FFFA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14062 7.3682C6.14062 6.68996 6.69045 6.14014 7.36869 6.14014H7.38097C8.05921 6.14014 8.60903 6.68996 8.60903 7.3682C8.60903 8.04644 8.05921 8.59626 7.38097 8.59626H7.36869C6.69045 8.59626 6.14062 8.04644 6.14062 7.3682Z",
    fill: "#5FFFA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.3017a1ea6775f3997ee71c42b7c284ea.svg";
export { ForwardRef as ReactComponent };